export default __webpack_public_path__ + "static/media/33_Gopniki.e610b4db.JPG";